export const PREVIEW_MUSIC_LIST = [
    {
        musicTitle: 'Jannabi - Dreams',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=SJUWooZnfVQ',
        musicStartDuration: '219',
    },
    {
        musicTitle: 'Ed Sheeran - Perfect',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=2Vv-BfVoq4g',
        musicStartDuration: '21',
    },
    {
        musicTitle: 'Christina Perri - A Thousand Years',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=NZGHXy1IAHM&list=RDNZGHXy1IAHM&start_radio=1',
        musicStartDuration: '0',
    },
    {
        musicTitle: 'Nadhif - Kota Ini Tak Sama Tanpamu',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=grp6FCnioMM&list=RDgrp6FCnioMM&start_radio=1',
        musicStartDuration: '83',
    },
    {
        musicTitle: 'Tiara Andini - Pernikahan Kita',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=ZeFpigRaXbI&list=RDZeFpigRaXbI&start_radio=1',
        musicStartDuration: '113',
    },
    {
        musicTitle: 'Ed Sheeran - Photograph',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=KKQl-pIRQMY&list=RDKKQl-pIRQMY&start_radio=1',
        musicStartDuration: '52',
    },
    {
        musicTitle: 'Rizky Febian - Hingga Tua Bersama',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=8Zd06ebKDDg&list=RD8Zd06ebKDDg&start_radio=1',
        musicStartDuration: '54',
    },
    {
        musicTitle: 'Tiara Andini - Cintanya Aku',
        musicYoutubeURL: 'https://www.youtube.com/watch?v=sfuq3y_zuGw&list=RDZeFpigRaXbI&index=2',
        musicStartDuration: '177',
    }

];
